import { useHistory } from '@fs/zion-router'
import { useSlsDispatchContext, useSlsStateContext } from '@fs/zion-sls'
import { useCallback, useEffect, useRef } from 'react'
import {
  useSharedBrowserDispatchContext,
  useSharedBrowserStateContext,
} from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

export default function useImageBrowserSetup() {
  const sharedBrowserState = useSharedBrowserStateContext()
  const sharedBrowserDispatch = useSharedBrowserDispatchContext()
  const history = useHistory()

  const zionSlsState = useSlsStateContext()
  const { currentImageArk } = zionSlsState
  const zionSlsDispatch = useSlsDispatchContext()

  const thumbnails = sharedBrowserState.thumbnails

  const needsInit = useRef(true)
  const setIndexFromUrlArk = useCallback(() => {
    const imageArk = history.location.pathname.split('/').pop()
    if (!currentImageArk) zionSlsDispatch({ type: 'SET_DATA', value: { currentImageArk: imageArk } })
    if (thumbnails && thumbnails.length) {
      const idx = thumbnails.findIndex((img) => img.ark === imageArk)
      if (needsInit.current) {
        needsInit.current = false
        sharedBrowserDispatch({ type: 'SET_FOCUSED_INDEX', value: idx })
      }
    }
  }, [currentImageArk, history, sharedBrowserDispatch, thumbnails, zionSlsDispatch])

  // Initialize the focused index
  // Don’t load the image viewer into memory until the focusedIndex and images have been set.  Otherwise it will load image zero and then load the correct image
  // The first time focusedIndex is set, it's set from the ark in the browser url. We do this by finding it's index in the thumbnails, which were set from the apids
  useEffect(() => {
    setIndexFromUrlArk()
  }, [setIndexFromUrlArk])
}
